import _ from "lodash";
import {BLOG_POST_FILTER_CATEGORY, BLOG_POST_FILTER_FIELDS} from "../constants/blog.constant";

export {
    processBlogPostCategoryConfig,
    prepareBlogPostFilters,
}
const processBlogPostCategoryConfig = (blogPostCategoryConfig, category) => {
    if (!blogPostCategoryConfig.categories.includes(category)) {
        blogPostCategoryConfig.categories.push(category);
    }
}

const prepareBlogPostFilters = (blogPostCategoryConfig) => {
    let filterFields = [];
    // console.log(blogPostCategoryConfig)

    const categoryFilter = BLOG_POST_FILTER_CATEGORY;
    const options = _.map(blogPostCategoryConfig.categories, (category) => {
        return {key: category, label: category};
    });
    categoryFilter.options = _.sortBy(options, ['label']);

    /*if (categoryFilter.options.length > 0) {
        categoryFilter.default = categoryFilter.options[0].key;
    }*/

    filterFields.push(categoryFilter);
    filterFields = _.concat(filterFields, BLOG_POST_FILTER_FIELDS);

    return filterFields;
}
